export default {
  tag: 'Teste',
  tag_tooltip: 'Restaurante de teste: totalmente funcional, nunca faturado.',
  card: {
    title: 'Restaurante de teste',
    description:
      'Marque um restaurante como o seu restaurante de teste para experimentar impressão, e-mails, encomendas e integrações em produção. Funciona como qualquer outro restaurante e nunca é faturado. Os e-mails e SMS dos clientes sobre as suas encomendas começam com [TEST].',
    payments_note:
      'Os pagamentos no restaurante de teste são reais e pagos como qualquer outro. Reembolse as encomendas de teste você próprio. Somos notificados quando as vendas mensais ultrapassam o nível de teste.',
    designated_on: 'Marcado como teste em {{date}}',
    open_shop: 'Abrir loja',
    remove: 'Remover designação de Teste',
    select_placeholder: 'Escolha um restaurante',
    mark: 'Marcar como restaurante de teste',
    no_restaurants: 'Ainda não tem nenhum restaurante para marcar.',
    load_error: 'Não foi possível carregar o seu restaurante de teste.',
  },
  remove_confirm: {
    title: 'Remover a designação de Teste de {{name}}?',
    description_live:
      'A faturação deste restaurante é retomada e fica offline de imediato. Relance-o em Definições de encomenda → Métodos de Encomenda → Encomendas em direto, onde escolhe o seu plano.',
    description_stays_live:
      'Este restaurante continua ativo e volta a ser tratado como os seus outros restaurantes a partir de agora.',
    description_offline:
      'A faturação deste restaurante é retomada quando ficar em direto. O seu plano é escolhido quando o lançar.',
    confirm: 'Remover designação de Teste',
  },
  toasts: {
    designated: '{{name}} é agora o seu restaurante de teste. Não é faturado.',
    designate_error: 'Não foi possível marcar o restaurante como teste. Por favor, tente novamente.',
    removed: '{{name}} deixou de ser o seu restaurante de teste.',
    removed_offline: '{{name}} deixou de ser o seu restaurante de teste e está agora offline.',
    remove_error: 'Não foi possível remover a designação de Teste. Por favor, tente novamente.',
  },
};
